import { Flex, Text } from "@/atoms"
import { useTranslation } from "@/hooks/useTranslation"
import { getTitle } from "./helpers"

import styles from "./TitleIssueDescriptionKai.module.scss"

import type { IssueDescriptionKaiProps } from "../.."

export const TitleIssueDescriptionKai = (props: IssueDescriptionKaiProps) => {
  const { t } = useTranslation("translation", {
    keyPrefix: "triage.drawer.kai.sast.title"
  })
  const { title, subTitle } = getTitle(props, t)

  return (
    <Flex vertical>
      <Text className={styles.title}>{title}</Text>
      <Text className={styles.subtitle}>{subTitle}</Text>
    </Flex>
  )
}
